module.exports = __webpack_public_path__ + "static/media/IMG_0702.5781c3f5.HEIC";